module.exports = __webpack_public_path__ + "img/switzerland-infectious-diseases-female.3e54cba0.png";